import { Invitation } from '../InvitationsGrid/types';
import { formatIsoDateInput } from '../InvitationsGrid/expiresDateUtils';
import { revokeInvitationLink } from '../../invitationUrlUtils';
import { InviteMemberFormData } from './types';

export const ALREADY_ON_TEAM_INVITE_MESSAGE =
  'The user is already part of the Team. The invitation will not be sent';

export function invitationToInviteFormValues(
  invitation: Invitation,
): Partial<InviteMemberFormData> {
  return {
    email: invitation.email,
    teamId: invitation.teamId ?? '',
    roles: invitation.roleIds ?? [],
    applications: invitation.applications,
  };
}

export function buildResentExpiresAt(from = new Date()): string {
  const expires = new Date(from);
  expires.setDate(expires.getDate() + 7);
  return formatIsoDateInput(expires);
}

export function applyResentInvitationUpdate(
  invitation: Invitation,
  data: InviteMemberFormData,
  link: string,
): Invitation {
  return {
    ...invitation,
    email: data.email,
    teamId: data.teamId,
    roles: data.roles,
    roleIds: data.roles,
    applications: data.applications,
    status: 'pending',
    expiresAt: buildResentExpiresAt(),
    link,
  };
}

export function applyRevokedInvitationUpdate(
  invitation: Invitation,
): Invitation {
  revokeInvitationLink(invitation.link);

  return {
    ...invitation,
    status: 'revoked',
  };
}

export async function copyTextToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

export function isEmailAlreadyOnTeam({
  email,
  teamId,
  invitations,
  ignoreInvitationId,
}: {
  email: string;
  teamId: string;
  invitations: readonly Invitation[];
  ignoreInvitationId?: string;
}): boolean {
  const normalizedEmail = email.trim().toLowerCase();
  if (!normalizedEmail || !teamId) {
    return false;
  }

  return invitations.some(
    invitation =>
      invitation.id !== ignoreInvitationId &&
      invitation.status === 'pending' &&
      invitation.email.toLowerCase() === normalizedEmail &&
      invitation.teamId === teamId,
  );
}
